module.exports = __webpack_public_path__ + "img/set5.c4e5bf45.svg";